export default __webpack_public_path__ + "static/media/greenspakuranga.f2f9a47a.png";